import PropTypes from "prop-types";
import { PureComponent } from "react";

import { FormattedMessage, defineMessages, injectIntl } from "react-intl";

import { Link, withRouter } from "react-router-dom";

import { connect } from "react-redux";

import { fetchServer } from "flavours/glitch/actions/server";
import { ServerHeroImage } from "flavours/glitch/components/server_hero_image";
import { ShortNumber } from "flavours/glitch/components/short_number";
import { Skeleton } from "flavours/glitch/components/skeleton";
import Account from "flavours/glitch/containers/account_container";
import { domain } from "flavours/glitch/initial_state";

const messages = defineMessages({
  aboutActiveUsers: { id: "server_banner.about_active_users", defaultMessage: "People using this server during the last 30 days (Monthly Active Users)" },
});

const mapStateToProps = state => {
  const server = state.getIn(["server", "server"]);
  const contactId = server.getIn(["contact", "account", "id"]);

  return {
    server,
    // Only show the administrator when the account is actually known, otherwise it stays a skeleton
    hasContactAccount: !!contactId && !!state.getIn(["accounts", contactId]),
  };
};

class ServerBanner extends PureComponent {

  static propTypes = {
    server: PropTypes.object,
    hasContactAccount: PropTypes.bool,
    dispatch: PropTypes.func,
    intl: PropTypes.object,
    history: PropTypes.object,
  };

  // The whole banner leads to /about, like on Mastodon (links inside keep working)
  handleClick = e => {
    if (e.target.closest("a, button")) {
      return;
    }

    this.props.history.push("/about");
  };

  handleKeyDown = e => {
    if (e.key === "Enter" && e.target === e.currentTarget) {
      this.props.history.push("/about");
    }
  };

  componentDidMount () {
    const { dispatch } = this.props;
    dispatch(fetchServer());
  }

  render () {
    const { server, intl, hasContactAccount } = this.props;
    const isLoading = server.get("isLoading");
    const activeUsers = server.getIn(["usage", "users", "active_month"]);
    const heroUrl = server.getIn(["thumbnail", "url"]);

    return (
      <div className='server-banner' role='link' tabIndex={0} style={{ cursor: "pointer" }} onClick={this.handleClick} onKeyDown={this.handleKeyDown}>
        <div className='server-banner__introduction'>
          <FormattedMessage id='server_banner.introduction' defaultMessage='{domain} is part of the decentralized social network powered by {mastodon}.' values={{ domain: <strong>{domain}</strong>, mastodon: <a href='https://gotosocial.org' target='_blank' rel="noreferrer">GoToSocial</a> }} />
        </div>

        {(isLoading || heroUrl) && <ServerHeroImage blurhash={server.getIn(["thumbnail", "blurhash"])} src={heroUrl} className='server-banner__hero' />}

        <div className='server-banner__description'>
          {isLoading ? (
            <>
              <Skeleton width='100%' />
              <br />
              <Skeleton width='100%' />
              <br />
              <Skeleton width='70%' />
            </>
          ) : server.get("description")}
        </div>

        <div className='server-banner__meta'>
          {hasContactAccount && (
            <div className='server-banner__meta__column'>
              <h4><FormattedMessage id='server_banner.administered_by' defaultMessage='Administered by:' /></h4>

              <Account id={server.getIn(["contact", "account", "id"])} size={36} />
            </div>
          )}

          {(isLoading || typeof activeUsers === "number") && <div className='server-banner__meta__column'>
            <h4><FormattedMessage id='server_banner.server_stats' defaultMessage='Server stats:' /></h4>

            {isLoading ? (
              <>
                <strong className='server-banner__number'><Skeleton width='10ch' /></strong>
                <br />
                <span className='server-banner__number-label'><Skeleton width='5ch' /></span>
              </>
            ) : (
              <>
                <strong className='server-banner__number'><ShortNumber value={activeUsers} /></strong>
                <br />
                <span className='server-banner__number-label' title={intl.formatMessage(messages.aboutActiveUsers)}><FormattedMessage id='server_banner.active_users' defaultMessage='active users' /></span>
              </>
            )}
          </div>}
        </div>

        <hr className='spacer' />

        <Link className='button button--block button-secondary' to='/about'><FormattedMessage id='server_banner.learn_more' defaultMessage='Learn more' /></Link>
      </div>
    );
  }

}

export default connect(mapStateToProps)(injectIntl(withRouter(ServerBanner)));
